import PropTypes from 'prop-types';
import { Box, TextField, Typography } from '@mui/material';
import { standardFieldLabelSx } from './formLabelStyles';

const LabeledField = ({ label, placeholder, helperText, children, sx, textFieldSx, ...props }) => (
  <Box sx={sx}>
    <Typography variant="body2" sx={standardFieldLabelSx}>
      {label}
    </Typography>
    <TextField
      fullWidth
      placeholder={placeholder || label || "Enter"}
      helperText={helperText}
      sx={textFieldSx}
      {...props}
    >
      {children}
    </TextField>
  </Box>
);

LabeledField.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  helperText: PropTypes.node,
  children: PropTypes.node,
  sx: PropTypes.object,
  textFieldSx: PropTypes.object,
};

LabeledField.defaultProps = {
  placeholder: '',
  helperText: null,
  children: null,
  sx: undefined,
  textFieldSx: undefined,
};

export default LabeledField;
